import { MapsAPILoader } from '@ng-maps/core'
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'

@Component({
  selector: 'app-google-autocomplete',
  templateUrl: './google-autocomplete.component.html',
  styleUrls: ['./google-autocomplete.component.scss']
})
export class GoogleAutocompleteComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() addressType: string
  @Input() locationTxt: any
  @Input() readOnly = false
  @Input() openModal: any
  @Input() fromGroup = false;
  @Output() setAddress: EventEmitter<any> = new EventEmitter()
  @Output() unFocusInput: EventEmitter<any> = new EventEmitter()
  @ViewChild('addresstext', { static: true }) addresstext: any
  @Output() invalidAddress = new EventEmitter<void>();

  constructor (private mapsAPILoader: MapsAPILoader, private ngZone: NgZone) {}

  ngOnInit () {
    if (this.locationTxt) {
      this.addresstext.nativeElement.value = this.locationTxt
    }
    // Cargo Places Autocomplete
    this.mapsAPILoader.load().then(() => {

      let options: google.maps.places.AutocompleteOptions = {};
      if (this.addressType === 'airport') {
        options.types = ['airport'];
      }

      const autocomplete = new google.maps.places.Autocomplete(
        this.addresstext.nativeElement,
        options
      );

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // Obtengo el resultado (place)
          const place: google.maps.places.PlaceResult = autocomplete.getPlace()

          // Verifico que tengo resultado
          if (place.geometry === undefined || place.geometry === null) {
            return
          }

          if (this.fromGroup) {
            const types = place.types || [];

            if (this.addressType === 'geocode' && !this.isCityOrCountry(place)) {
              this.invalidAddress.emit();
              this.addresstext.nativeElement.value = '';
              this.locationTxt = '';
              return;
            }

            if (this.addressType === 'airport' && !types.includes('airport')) {
              this.invalidAddress.emit();
              this.addresstext.nativeElement.value = '';
              this.locationTxt = '';
              return;
            }
          }

          // Mando el evento con el lugar
          this.setAddress.emit(place)
        })
      })
    })
  }

  private isCityOrCountry(place: google.maps.places.PlaceResult): boolean {
    const types = place.types || [];
    const components = place.address_components || [];

    const isCity = types.includes('locality') || components.some(c => c.types.includes('locality'));
    const isCountry = types.includes('country') || components.some(c => c.types.includes('country'));

    return isCity || isCountry;
  }

  ngAfterViewInit (): void {
    const elements = document.getElementsByClassName('cdk-global-scrollblock')
    if (elements.length > 0) {
      const firstElement = elements[0] as HTMLElement
      firstElement.style.top = '0'
    }
  }

  disableEnter (event) {
    if (event.code === 'Enter') {
      event.preventDefault()
      // this.unFocusInput.emit(event);
    }
  }

  reset() {
    this.locationTxt = '';
    if (this.addresstext && this.addresstext.nativeElement) {
      this.addresstext.nativeElement.value = '';
    }
  }

  ngOnDestroy (): void {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }
}
